/**
 * Memoizes the last invocation of a function with the same memo keys.
 * As long as key identity and set doesn't change, the last computed
 * value will be returned.
 */
export function memoByKeys(fn, getKeys) {
    let cachedKeys;
    let cachedResult;
    return (...args) => {
        const keys = getKeys();
        if (cachedKeys &&
            cachedKeys.length === keys.length &&
            cachedKeys.every((key, i) => key === keys[i])) {
            return cachedResult;
        }
        cachedKeys = [...keys];
        cachedResult = fn(...args);
        return cachedResult;
    };
}
//# sourceMappingURL=memo.js.map